const conversionFactor1 = 0.683;
const conversionFactor2 = 0.00439;

export const blenderLightToThree = (watt: number) => {
  // Calculate the Three.js light's original intensity using conversionFactor1
  const threeJSOriginalIntensity = watt * conversionFactor1;

  // Calculate the Three.js light's adjusted intensity using conversionFactor2
  const threeJSAdjustedIntensity = threeJSOriginalIntensity * conversionFactor2;

  return threeJSAdjustedIntensity;
}

export const lerp = (start: number, end: number, t: number) => {
  return start * (1 - t) + end * t
}